import { SVGProps } from 'react';

const WineOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 22h8M7 10h3m4.391 4.391A5 5 0 0 1 7 10c.003-.906.106-1.81.307-2.693M17 10h-1.343M17 10c0-2-.5-4-2-8H9q-.193.51-.362.981M17 10q-.001.613-.145 1.198M12 15v7M2 2l20 20"
    />
  </svg>
);
export default WineOff;
